import ApiService from '../api.service'
import SystemJwtService from "../systemJwt.service";
import DefaultHandlers from '../defaultHandlers.service';

const ComparadorService = {
    api: new ApiService('https://investirseguro-api-comparador.smartbrain.com.br/api' + "/comparador", () => DefaultHandlers.success(), (error) => DefaultHandlers.failure(error)),
    
    async obterTokenCarteira() {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.get(`/obterTokenCarteira`).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: true,
                mensagem: response.data.mensagem,
                token: response.data.token
            }
        });

        return response;
    },
    async validarTokenCarteira(token) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.get(`/validarTokenCarteira?token=${token}`).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: true,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async obterTiposAtivos() {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.get(`/obterTiposAtivos`).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a lista.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                tipos: response.data.tipos
            }
        });

        return response;
    },
    async buscarAtivos(termoBusca, tipoInvestimento) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.get(`/buscarAtivos?termoBusca=${termoBusca}&tipoInvestimento=${tipoInvestimento}`).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a lista.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                ativos: response.data.ativos
            }
        });

        return response;
    },
    async enviarEmail(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/enviarEmail", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a lista.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async obterDatasInvalidas() {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.get(`/obterDatasInvalidas`).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter as datas.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                datas: response.data.datas
            }
        });

        return response;
    },
    async obterEvolucaoRentabilidadeGrafico(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/obterEvolucaoRentabilidadeGrafico", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a lista.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                evolucaoRentabilidade: response.data.evolucaoRentabilidade
            }
        });

        return response;
    },
    async obterRentabilidadesTabelaAtivos(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/obterRentabilidadesTabelaAtivos", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter a lista.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                rentabilidades: response.data.rentabilidades
            }
        });

        return response;
    },
    
    async salvarAtivoSelecionado(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/salvarAtivoSelecionado", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async removerAtivoCarteira(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/removerAtivoCarteira", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async obterSaldoAtivoParaData(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/obterSaldoAtivoParaData", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                saldo: response.data.saldo,
            }
        });

        return response;
    },
    async aplicarMovimentoAtivo(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/aplicarMovimentoAtivo", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async resgatarMovimentoAtivo(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/resgatarMovimentoAtivo", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async obterMovimentosAtivo(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/obterMovimentosAtivo", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                movimentos: response.data.movimentos,
            }
        });

        return response;
    },
    async removerMovimentoAtivo(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/removerMovimentoAtivo", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    },
    async loginCarteira(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/loginCarteira", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem,
                token:  response.data.token
            }
        });

        return response;
    },
    async salvarCarteira(dados) {
        this.api.setJwtToken(await SystemJwtService.getSystemJwtToken());
        
        const response = this.api.post("/salvarCarteira", dados).then((response) => {
            if (response == null) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status === 401) {
                return {
                    sucesso: false,
                    mensagem: "Não foi possível obter resposta.",
                }
            } else if (response.status !== 200) {
                return {
                    sucesso: false,
                    mensagem: "Erro ao fazer a requisição.",
                }
            }

            return {
                sucesso: response.data.sucesso,
                mensagem: response.data.mensagem
            }
        });

        return response;
    }
}

export default ComparadorService;